export const ENV = {
  LOCAL: "local",
  DEV: "dev",
  QA: "qa",
  SANDBOX: "sandbox",
  PRODUCTION: "prod",
};
